import { IConfig } from '@qunhe/ktracker-types';
import SystemOptions from '../../utils/options';
import globalError from './globalError';
import unhandledRejection from './unhandledRejection';

export default function collectError(opts: IConfig) {
  globalError(opts);

  const options = SystemOptions.getInstance().getOptions();

  if (options.getUnhandledrejection) {
    unhandledRejection(opts);
  }
}
